module.exports = __webpack_public_path__ + "static/media/hamburger-icon.ca9ed13d.svg";